// Core
import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { NavLink } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import {
  AbsoluteCenter,
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  Divider,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Input,
  InputGroup,
  InputRightElement,
  Image,
  IconButton,
  Link,
  Text,
  useColorModeValue,
  useDisclosure,
  useColorMode
} from '@chakra-ui/react';

// Assets
import logo from 'assets/img/logo.png';
import { apiService } from 'services/ApiService';
import { validateEmail, validatePassword } from 'services/Utils';
import { ReactComponent as ForgotIcon } from 'assets/svg/forgot-back.svg';

function Forgot() {
  const dividerColor = useColorModeValue('rgba(0, 0, 0, 0.03)', '#262D47');
  const dividerOrColor = useColorModeValue('#7787B0', '#E1E1E1');
  const borderColor = useColorModeValue('gray.200');
  const backgroundColor = useColorModeValue('#141831', '#141831');
  const featureColor = '#8794C2';

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');

  const [show, setShow] = React.useState(false);
  const [show2, setShow2] = React.useState(false);

  const [differentErrorPassword, setDifferentErrorPassword] = useState(false);
  const [patternsErrorPassword, setPatternsErrorPassword] = useState(false);
  const [isValidErrorCode, setValidErrorCode] = useState(false); 

  const [step, setStep] = useState(1);

  const [isValid, setIsValid] = useState(false);
  const [isValid2, setIsValid2] = useState(false);

  const [isValidInputEmail, setIsValidInputEmail] = useState(true);  
  const [isValidInputPhone, setIsValidInputPhone] = useState(true); 
  const [isValidInputCode, setIsValidInputCode] = useState(true); 
  const [isValidInputPassword, setIsValidInputPassword] = useState(true); 
  const [isValidInputRePassword, setIsValidInputRePassword] = useState(true); 

  const { isOpen, onOpen } = useDisclosure();

  const handlePassClick = () => setShow(!show); 
  const handlePassClick2 = () => setShow2(!show2); 

  const handleEmailChange = (event) => {
    const inputEmail = event.target.value;
    setEmail(inputEmail);
    setIsValid(validateEmail(inputEmail));
    setIsValidInputEmail(true);
  };
  const handlePhoneChange = value => {
    setPhone(value);
    setIsValid(value && value.length > 0 ? true : false);
    setIsValidInputPhone(true);
  };
  const handleCodeChange = (event) => {
    const value = event.target.value;
    if (value.length <= 6) {
      setCode(event.target.value);
    }

    if(event.target.value.length === 0 || password.length === 0 || rePassword.length === 0){
      setIsValid2(false);
    } else {
      setIsValid2(true);
    }

    setValidErrorCode(false);
    setIsValidInputCode(true);
  };
  const handlePasswordChange = (event) => {
    const value = event.target.value;

    setPassword(value);

    if(code.length === 0 || value.length === 0 || rePassword.length === 0){
      setIsValid2(false);
    } else {
      setIsValid2(true);
    }

    setDifferentErrorPassword(false);
    setPatternsErrorPassword(false);
    setIsValidInputPassword(true);
  };
  const handleRePasswordChange = (event) => {
    setRePassword(event.target.value);
    if(code.length === 0 || password.length === 0 || event.target.value.length === 0){
      setIsValid2(false);
    } else {
      setIsValid2(true);
    }

    setDifferentErrorPassword(false);
    setIsValidInputRePassword(true);
  };

  const handleSubmitEmailPhone = async (event) => {
    event.preventDefault();  

    const data = {};
    let error = false;
    if(email){
      data['email'] = email;
    } else if(phone){
      data['phone'] = phone;
    } else {
      return;
    }

    try {
      const response = await apiService.forgotPassword(data);
      if(response.statusCode === 200){
        setStep(2);
      } else {
        error = true;
      }
    } catch (e) { error = true; }

  
    if(error){
      if(email){
        setIsValidInputEmail(false);
      } else {
        setIsValidInputPhone(false);
      }
    }
  };

  const handleSubmitForgot = async (event) => {
    event.preventDefault();
    let error = false;

    try {
      if(password !== rePassword){
        setIsValidInputPassword(false);
        setIsValidInputRePassword(false);
        setDifferentErrorPassword(true);
        error = true;
      }

      if (!validatePassword(password)) {
        setPatternsErrorPassword(true);
        error = true;
      }

      if(code.length < 6){
        setValidErrorCode(true);
      }

      const data = { code, password };

      if(email){
        data['email'] = email;
      } else if(phone){
        data['phone'] = phone;
      } else {
        error = true;
      }

      if(!error){
        const response = await apiService.forgotPasswordConfirm(data);
        if(response){
            onOpen();
        } else {
          setValidErrorCode(true);
          error = true;
        } 
      }
    } catch (e) { error = true; }

    if(error){
      if (code.length !== 6) {
          setIsValidInputCode(false);
      }
      setIsValidInputPassword(false);
      setIsValidInputRePassword(false);
    }
  };

  return (
    <Box w='100%' textAlign="center">
      <Box mb={{base: '50px', sm: '60px', md: '79px'}} display="flex" alignItems="center" justifyContent="center">
        <NavLink to="/"><Image src={logo} alt='lmctplus image' maxWidth="184px"/></NavLink>
        { isDark && <Box bg="rgba(64, 155, 255, 0.82)" zIndex="-1" position="absolute" opacity="0.6" filter="blur(70px)" h="300px" w="200px" mt="10%" borderRadius="full" /> }
      </Box>

      <Text variant="header-gradient" fontSize={{base: '32px', sm: '40px', md: '48px'}} mb="16px">Reset Password </Text>

      <Text variant="title-lg" fontSize={{base: '16px', md: '20px'}} fontWeight="400" mb={{base: '32px', md: '48px'}}>
        { step === 1 ? 
          'Enter your email or mobile phone number and we`ll send you instructions to reset your password'
          : 'Verification Code has been sent to you. Please enter it below together with the new Password.'
        }
      </Text>

      {step === 1 && (
        <Box maxW={{sm: '100%', md: '81%'}} m="0 auto" position="relative">
          <FormControl id="email">
            <Input
                value={email}
                onChange={handleEmailChange}
                type='email'
                placeholder='Email'
                autoComplete="off"
                className={isValidInputEmail ? 'input-valid' : 'input-invalid'}/>
            <FormHelperText className={isValidInputEmail ?  'hidden' : 'input-error'}>This email does not exist</FormHelperText>
          </FormControl>  

          <Flex alignItems="center" gap="8px" w="100%" py="12px">
            <Box w="100%" borderTopWidth="1px" borderColor={dividerColor} />
            <Text variant="text-sm" color={dividerOrColor}>or</Text>
            <Box w="100%" borderTopWidth="1px" borderColor={dividerColor} />
          </Flex>
          
          <FormControl>
            <PhoneInput
              international
              countryCallingCodeEditable={false}
              defaultCountry="US"
              value={phone}
              onChange={handlePhoneChange}
              mb='24px'
              pt='15px'
                type='text'
                placeholder=''
                autoComplete="off"
                color='gray.200'
                className={isValidInputPhone ? 'input-valid' : 'input-invalid'}/>
            <FormHelperText top="2px" className={isValidInputPhone ?  'hidden' : 'input-error'}>This phone does not exist</FormHelperText>
              <Button
                onClick={handleSubmitEmailPhone}
                variant="button-md"
                disabled={!isValid}
                mb='24px'>
                Reset password
              </Button>
          </FormControl>
        </Box>
      )}

      { step === 2 && (
        <Box maxW={{sm: '100%', md: '81%'}} m="0 auto">
          
          <FormControl variant="floatingForgot" id="code">
            <Input
                value={code}
                onChange={handleCodeChange}
                mb='24px'
                className={isValidInputCode ? 'input-valid' : 'input-invalid'}
                type='number'
                max="6"
                style={{background: '#0a152a !important'}}
                placeholder=''
                autoComplete="off"/>
            <FormLabel htmlFor="code" className={isValidInputCode ? 'input-valid' : 'input-invalid'}>Code</FormLabel>
            <FormHelperText className={isValidErrorCode ? 'input-error' : 'hidden'}>Code invalid</FormHelperText>
          </FormControl>

          <FormControl variant="floatingForgot" id="password">
            <InputGroup size='md'>
              <Input
                value={password}
                onChange={handlePasswordChange}
                className={isValidInputPassword ? 'input-valid' : 'input-invalid'}
                mb='24px'
                placeholder=''
                autoComplete="off"
                style={{background: '#0a152a !important'}}
                type={show ? 'text' : 'password'}
              />
              <FormLabel htmlFor="password" className={isValidInputPassword ? 'input-valid' : 'input-invalid'}>New password</FormLabel>
              <FormHelperText className={patternsErrorPassword ? 'input-error' : 'hidden'}>Password needs 8+ chars, upper & lower case, numbers</FormHelperText>
              <InputRightElement>
                <IconButton
                  aria-label={show ? 'Hide password' : 'Show password'}
                  icon={show ?  <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  onClick={handlePassClick}
                  mt='14px'
                  mr='14px'
                  color='gray.200'
                  fontSize='24px'
                  variant='ghost-md'
                />
               </InputRightElement>
            </InputGroup>
          </FormControl>

          <FormControl variant="floatingForgot" id="rePassword">
            <InputGroup size='md'>
              <Input
                value={rePassword}
                onChange={handleRePasswordChange}
                borderColor={borderColor}
                className={isValidInputRePassword ? 'input-valid' : 'input-invalid'}
                mb='16px'
                placeholder=''
                type={show2 ? 'text' : 'password'}
              />
              <FormLabel htmlFor="rePassword" className={isValidInputRePassword ? 'input-valid' : 'input-invalid'}>Enter your new password again</FormLabel>
              <FormHelperText className={differentErrorPassword ? 'input-error' : 'hidden'}>Different password</FormHelperText>
              <InputRightElement>
                <IconButton
                  aria-label={show2 ? 'Hide password' : 'Show password'}
                  icon={show2 ?  <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                  onClick={handlePassClick2}
                  mt='14px'
                  mr='14px'
                  color='gray.200'
                  fontSize='24px'
                  variant='ghost-md'
                />
              </InputRightElement>
              <FormErrorMessage>Email is required.</FormErrorMessage>
            </InputGroup>

            <Text mb="24px" variant="text-sm" fontSize="13px" color="#9FABCB">
              Your password must be at least 8 characters long, contain 1 letter, 1 uppercase letter and 1 number
            </Text>

            <Button
              onClick={handleSubmitForgot}
              variant="button-md"
              disabled={!isValid2}
              mb='24px'>
              Confirm
            </Button>

          </FormControl>
        </Box>
      )}
      
      <a href="/auth/login">
        <Flex justifyContent="center" w="100%" my="16px" gap="8px" alignItems="center">
          <ForgotIcon />
          <Text color="#099BFF">Back to Login</Text>
        </Flex>
      </a>

      <Modal isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent className="modal__simple" maxW={{ sm: '472px' }}>
          <ModalHeader display="center" alignItems="center" justifyContent="center">Congratulations</ModalHeader>
          <ModalBody>
            <Text variant="text-md" display="center" alignItems="center" justifyContent="center" mt="12px" mb="24px">
              Password changed successfully
            </Text>
            <NavLink to='/auth/login' >
              <Button variant="button-md" w='100%'>Log In</Button>
            </NavLink>
          </ModalBody>
        </ModalContent>
      </Modal> 

    </Box>
  );
}

export default Forgot;
